import React, { useEffect, useRef, useState } from 'react';
import styles from './ProudlyLocal.module.css';
import Button from '../../components/Button';

const ProudlyLocal: React.FC = () => {
  const [isVisible, setIsVisible] = useState(false);
  const [visibleElements, setVisibleElements] = useState<number[]>([]);
  const contentRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            setIsVisible(true);
            // Staggered animation for individual elements
            const elements = ['h1', 'p1', 'p2', 'p3', 'button'];
            elements.forEach((_, index) => {
              setTimeout(() => {
                setVisibleElements(prev => {
                  if (!prev.includes(index)) {
                    return [...prev, index];
                  }
                  return prev;
                });
              }, index * 300);
            });
          }
        });
      },
      { threshold: 0.3 }
    );

    if (contentRef.current) {
      observer.observe(contentRef.current);
    }

    return () => observer.disconnect();
  }, []);

  return (
    <section className={styles.proudlyLocalSection}>
      <div 
        ref={contentRef}
        className={`${styles.proudlyLocalContent} ${isVisible ? styles.fadeInVisible : styles.animationHidden}`}
      >
        <h1 className={visibleElements.includes(0) ? styles.zoomInVisible : styles.animationHidden}>
          Proudly Local
        </h1>
        {/* <p className={visibleElements.includes(1) ? styles.zoomInVisible : styles.animationHidden}>
          We're a small, dedicated tiling business based in the heart of beautiful Revelstoke, BC.
        </p> */}
        <p className={visibleElements.includes(2) ? styles.zoomInVisible : styles.animationHidden}>
          As locals, we take great pride in serving our community with high-quality craftsmanship, personalized service, and a commitment to making every home and business space shine.
        </p>
        {/* <p className={visibleElements.includes(3) ? styles.zoomInVisible : styles.animationHidden}>
          When you work with us, you're supporting local trades — and getting results you'll love.
        </p> */}
        <div className={visibleElements.includes(4) ? styles.zoomInVisible : styles.animationHidden}>
          <Button 
            onClick={() => {
              const contactSection = document.querySelector('#contact');
              contactSection?.scrollIntoView({ behavior: 'smooth' });
            }}
          >
            Contact Us
          </Button>
        </div>
      </div>
    </section>
  );
};

export default ProudlyLocal;